
import Component from "vue-class-component";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";

import {
    AddInlandVesselPracticeRequest,
    factory, PracticesClient,
    InlandVesselPracticeActions,
} from "@/api-client";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import InlandVesselPracticeUpsertForm from "@/features/documents/practices/components/InlandVesselPracticeUpsertForm.vue";
import {PracticeAddBase} from "@/features/documents/practices/views/PracticeAddBase";

interface Props {
    seafarerId: string;
    actions: InlandVesselPracticeActions;
}

@Component({
    components: {
        FormLayout,
        InlandVesselPracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<AddInlandVesselPractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        Promise.all([
            new PracticesClient().availableInlandVesselActions()
        ]).then(values => {
            props.actions = values[0];
            next();
        }).catch(e => next(e))
    }
})
export default class AddInlandVesselPractice extends PracticeAddBase<AddInlandVesselPracticeRequest> implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: InlandVesselPracticeActions;

    model: AddInlandVesselPracticeRequest = factory.create(AddInlandVesselPracticeRequest);

    async submitPractice() {
        return await this.submit(this.model);
    }

    getDefaultReturnRouteName(): string {
        return "inland-vessel-practice-details";
    }
}
